import React from 'react';
import { connect } from 'react-redux';
import { callService } from '../tools';
import Modal from '../generalcomponets/modal-mobile';

const mapState = (state) => {
	return {
		familiar : state.af.familiar,
		listaPolizas: state.af.listaPolizas,
		listaGuardar: state.af.listaGuardar,
		listaVigencia: state.af.listaVigencia
	};
}

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		goTo: (paso) => {
			dispatch({ "type": "AF_EDITAR_PASO", "paso": paso });
		}
	}
}

class GestionarAcceso extends React.Component {

  state = {
    isModalOpened: false,
    modalOpen: true,
  }

  componentWillReceiveProps = () => {
    this.setState({ modalOpen: true });
  }

	reenviar = () => {
		let $this = this;
		$this.props.loader(true);

		let llamaServicio = new callService({
			service: 'accesoFamiliar.reenviaInvitacion',
			secure: true,
			data: {
				familiar: this.props.familiar.id
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.loader(false);
			$this.props.goTo(3);
		}).catch((error) => {
			console.log("Error", error);
			$this.props.loader(false);
			$this.props.alerta(error.message.mensaje);
		});
	}

	eliminar = () => {
		this.props.goTo(2);
	}

	gestionar = () => {
		this.props.goTo(1);
	}

	volver = () => {
    this.setState({ isModalOpened: false})
		$("#modal-gestionar").modal("toggle");
	}

  capital_letter = (str) => {
	  if(str){
		str = str.split(" ");
		for(let i = 0; i < str.length; i++) {
			str[i] = str[i][0].toUpperCase();
			}
		return str.join("");
	  }
    
  }

  closeModalFromChild = (e) => {
    if(e.target.id === "modalGestionar") {
      this.setState({ modalOpen: false });
    }
  }

	render() {
    return (
      <div>
        {this.state.modalOpen &&
          <div id="modalGestionar" className="GNP-modal" onClick={this.closeModalFromChild.bind(this)}>
            <div className="GNP-modal-content">
              <div className="GNP-modal-body">
                <h5 className="title-mail">Acceso a pólizas</h5>
                <div className="row acceso-container">
                  <div className="col-xs-12 mb-10">
                    <div className="row">
                      <div className="col-xs-2 col-md-2">
                        <div className="circle-name">{this.capital_letter(this.props.familiar.nombre)}</div>
                      </div>
                      <div className="col-xs-7 col-md-6">
                        <span className="name-access">{this.props.familiar.nombre}</span>
                        { this.props.familiar.pendiente == true &&
                          <p><small className="text-status">Invitación aceptada</small></p>
                        }
                        { this.props.familiar.pendiente == false && this.props.familiar.polizas.length != 0 &&
                          <p><small className="text-status">Pendiente de aceptar</small></p>
                        }
                        { this.props.familiar.pendiente == false && this.props.familiar.polizas.length == 0 &&
                          <p><small className="text-status"><span className="red-circle-no"></span>Sin pólizas compartidas</small></p>
                        }
                      </div>
                      <div className="col-xs-3 col-md-4">
                        <small className="text-status">{`${this.props.familiar.polizas.length} Pólizas`}</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row acceso-container">
                  <div className="col-xs-12 mb-10">
                    {this.props.listaPolizas.length > 0 &&
                      <div className="overflow-wrap mt-10">
                        <ul>
                          { this.props.listaPolizas.map((item, i) => {
                            if(this.props.familiar.polizas.indexOf(item.generales.numPoliza) != -1) {
                              return (
                                <li key={i} className="clearfix">
                                  <div className="col-xs-10" style={{"padding":"10px"}}>
                                    <span className="desc-box">{item.vehiculo.descripcion}</span>
                                    <span className="desc-detail">{item.vehiculo.placas} - {item.vehiculo.modelo}</span>
                                  </div>
                                  <div className="col-xs-2">
                                    <div className="checkbox-blue text-center">
                                      <input type="checkbox" checked disabled />
                                      <label></label>
                                    </div>
                                  </div>
                                  <div className="col-xs-12">
                                    <div className="border-box"></div>
                                  </div>
                                  <div className="col-xs-12">
                                    <span>No. Póliza: {item.generales.numPoliza}</span>
                                  </div>
                                </li>
                              )
                            }
                          })}
                        </ul>
                      </div>
                    }
                    <div className="polizas-opciones row">
                      <div className="col-xs-12">
                        <div className="gestion-btns">
                          <a onClick={this.gestionar.bind(this)}>
                            <span>
                              Gestionar Pólizas
                              <i><img className="img-align" src={require("../img/arrow_right.png")}/></i>
                            </span>
                          </a>
                          <a onClick={this.eliminar.bind(this)}>
                            <span>
                              Eliminar invitado
                              <i><img className="img-align" src={require("../img/arrow_right.png")}/></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        }
      </div>
    )
	}
}

export default connect(mapState, mapDispatch)(GestionarAcceso);



// WEBPACK FOOTER //
// ./src/acceso-familiar/GestionarAccesoMovil.cmpt.js